export interface ILanguages {
    name: string;
    language: string;
}
